export const getEmployeesSalaryData = ({ employeesSalary }) =>
  employeesSalary.employeesSalary;
export const getEmployeesSalaryLoading = ({ employeesSalary }) =>
  employeesSalary.loaders.common;
export const getError = ({ employeesSalary }) => employeesSalary.errors.error;
export const getSuccess = ({ employeesSalary }) =>
  employeesSalary.success.success;
export const getStaffEmployeesSalaryDropDownSelector = ({ employeesSalary }) =>
  employeesSalary.staffDropDown;
